// @flow
import { handleResponseOld, makePost } from './helpers';

type PostUpcomingCatalogRegistrationParams = {
    authToken: string,
    catalogId: number,
    deployment: string,
};

export default {
    postUpcomingCatalogRegistration: ({ authToken, catalogId, deployment }: PostUpcomingCatalogRegistrationParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                authToken,
                deployment,
                path: '<ITEM-API>catalog/registration',
            });
            request.send({
                catalogIds: [catalogId],
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};

const transformLiveCatalogRegistration = response => {
    const { data, message, success } = response;
    if (data.approved && data.bidLimit) {
        return {
            data: {
                approved: data.bidLimit ? false : data.approved,
                bidLimit: data.bidLimit,
                catalogId: data.catalogId,
                publishKey: data.publishKey,
            },
            message,
            success,
        };
    }
    return response;
};

type PostLiveCatalogRegistrationParams = {
    authToken: string,
    catalogId: number,
    deployment: string,
    email: string,
    source: string,
};

export const postLiveCatalogRegistration = ({
    authToken,
    catalogId,
    deployment,
    email,
    source,
}: PostLiveCatalogRegistrationParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<CLERK-SERVICE>clerk/approval/${catalogId}`,
        });
        request.send({
            AuctionId: catalogId,
            Email: email,
            Source: source,
            Token: authToken,
        });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                success404: true,
                transform: transformLiveCatalogRegistration,
            })
        );
    });
